module.exports = __webpack_public_path__ + "img/1.329ccf7a.png";